import React from "react";
import "./work.css";
import Works from "./Works";

const Work = () => {
  return (
    <section className="work section" id="work">
      <span className="section__eyebrow">Selected Engagements</span>
      <h2 className="section__title work__title">Work</h2>
      <Works />
    </section>
  );
};

export default Work;
